import moment from "moment";

// True when the given timesheet date falls in a period locked for regular users.
// Current month: always open. Previous month: open through the 5th of the
// current month. Older months (and previous month after the 5th): locked.
export function isTimesheetPeriodLocked(date: moment.MomentInput): boolean {
  const now = moment();

  const entry = moment(date);

  if (entry.isSame(now, "month")) return false;

  const previousMonth = now.clone().subtract(1, "month");
  if (entry.isSame(previousMonth, "month") && now.date() <= 5) return false;

  return true;
}
